import React, { useState } from "react";
import Badge from "./Badge";
import ImagesModal from "./ImagesModal";
import { Tooltip } from "react-tooltip";
import { images } from "../assets/styles/Images";
import { mediaUrl, ticketResponseMediaUrl } from "../utils/config";
import moment from "moment";
const SupportTicketComment = ({
  personImage,
  personName,
  personStatus,
  tooltipDate,
  commentDate,
  commentMsg,
  commentImage,
  selectedTicketDetail,
  commentIndex,
}) => {
  const [openCommentImageModal, setOpenCommentImageModal] = useState({ open: false, data: null });
  const [selectedCommentImageIndex, setSelectedCommentImageIndex] = useState(0);

  const handleImageClick = (index) => {
    setSelectedCommentImageIndex(index); // Store the index of the clicked image
    setOpenCommentImageModal({ open: true, data: null }); // Open the modal
  };

  return (
    <>
      <div className="flex flex-col items-start gap-y-2">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-x-4">
            <div className="w-12 h-12 ">
              <img src={personImage} alt="person" className="w-full h-full rounded-full" />
            </div>
            <h2 className="text-base font-semibold text-secondary-color 3xl:text-lg">{personName}</h2>
            <Badge status={personStatus} />
          </div>
          <h2 id="commentdate" className="text-sm text-primary-color-200">
            {commentDate}
          </h2>
          <Tooltip
            anchorSelect="#commentdate"
            id="commentdate-tooltip"
            offset={5}
            className="border border-gray-100 !bg-white !text-primary-color-100 !opacity-100 shadow-card"
            classNameArrow="hidden"
            effect="solid"
            place="left"
          >
            {/* Tooltip Content */}
            <span>{tooltipDate}</span>
          </Tooltip>
        </div>

        <div className="ml-6 w-[95%] flex-grow space-y-5 border-l-2 py-4 pl-4 text-justify last:pb-0">
          <div className="pb-4 border-grayColor200 ">
            <p className="pb-4 text-sm text-grayColor400">{commentMsg}</p>
            <div className="relative flex gap-x-2">
              {commentImage?.slice(0, 3).map((image, index) => (
                <div
                  key={index}
                  className={`relative h-24 w-24 cursor-pointer rounded-xl border border-grayColor200`}
                  onClick={() => handleImageClick(index)}
                >
                  {/* Check if the file is a PDF */}
                  {image.endsWith(".pdf") ? (
                    <div className="flex items-center justify-center w-full h-full bg-gray-200 rounded-2xl">
                      <span>
                        <img src={images.PDF} className="w-16 h-16" alt="pdf-icon" />
                      </span>
                    </div>
                  ) : (
                    <img src={ticketResponseMediaUrl + "/" + image} className="object-cover w-full h-full rounded-2xl" alt={`Image ${index}`} />
                  )}
                  {index === 2 && commentImage.length > 3 && (
                    <div className="absolute inset-0 flex items-center justify-center rounded-xl bg-black/50">
                      <span className="text-xl font-bold text-white">{`+${commentImage.length - 3}`}</span>
                    </div>
                  )}
                </div>
              ))}

              {/* {commentImage?.slice(0, 3).map((image, index) => (
                <div
                  key={index}
                  className={`relative h-24 w-24 cursor-pointer rounded-xl border border-grayColor200`}
                  onClick={() => handleImageClick(index)}
                >
                  {console.log({commentImage})}
                  <img src={ticketResponseMediaUrl + "/" + image} className="object-cover w-full h-full rounded-2xl" alt={`Image ${index}`} />
                  {index === 2 && commentImage.length > 3 && (
                    <div className="absolute inset-0 flex items-center justify-center rounded-xl bg-black/50">
                      <span className="text-xl font-bold text-white">{`+${commentImage.length - 3}`}</span>
                    </div>
                  )}
                </div>
              ))} */}
            </div>
          </div>

          {/* <div className="flex items-center justify-center w-full !-mb-2">
            <div className={`h-[1px] w-full bg-grayColor200`}></div>
            <>
              {selectedTicketDetail?.status === "Closed" && commentIndex === selectedTicketDetail?.ticket_responses?.length - 1 && (
                <div className="w-full">
                  <div className="ml-5 text-sm text-grayColor400">
                    <span>Closed by </span>
                    <span className="text-sm font-medium text-grayColor300">{selectedTicketDetail?.closed_by}</span>
                    <span> at </span>
                    <span>{moment.unix(selectedTicketDetail?.updated_at_unix).format("D MMM YYYY h:mm A")}</span>
                  </div>
                </div>
              )}
            </>
          </div> */}
        </div>
      </div>
      <ImagesModal
        imagespdf={commentImage?.map((imageUrl) => ({
          original: ticketResponseMediaUrl + "/" + imageUrl,
          thumbnail: ticketResponseMediaUrl + "/" + imageUrl,
        }))}
        images={commentImage?.map((imageUrl) => ({
          original: imageUrl.endsWith(".pdf") ? images.PDF : ticketResponseMediaUrl + "/" + imageUrl,
          thumbnail: imageUrl.endsWith(".pdf") ? images.PDF : ticketResponseMediaUrl + "/" + imageUrl,
        }))}
        isOpen={openCommentImageModal.open}
        setIsOpen={(isOpen) => setOpenCommentImageModal({ ...openCommentImageModal, open: isOpen })}
        selectedImageIndex={selectedCommentImageIndex}
      />
    </>
  );
};

export default SupportTicketComment;
